import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_COMPLETED,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  CAMPAIGN_INTERNAL_STATUSES,
} from '../../shared/constants'

export const isDeclinedCampaign = ({ internalStatus, paymentStatus }) =>
  internalStatus === CAMPAIGN_INTERNAL_STATUSES.DRAFT &&
  (paymentStatus === 'refunded' || paymentStatus === 'canceled')

// TODO: @angelo pass subtype from campaign when enabled from the API
export const getMissionType = (type, subType) => {
  switch (type) {
    case CAMPAIGN_ENUM_TYPES.DIRECTMAIL:
      switch (subType) {
        case CAMPAIGN_SUBTYPES_ENUM.EDDM:
          return 'EDDM'
        case CAMPAIGN_SUBTYPES_ENUM.ADM:
          return 'ADM'
        default:
          return 'EDDM'
      }
    case CAMPAIGN_ENUM_TYPES.LETTERBOX:
      return 'D2D'
    case CAMPAIGN_ENUM_TYPES.HANDTOHAND:
      return 'H2H'
    case CAMPAIGN_ENUM_TYPES.INSERTS:
      return 'AIM'
    default:
      break
  }
}

export const getReadableStatus = status => {
  switch (status) {
    case STATUS_CAMPAIGN_ENUM_ACTIVE:
      return 'Active'
    case STATUS_CAMPAIGN_ENUM_COMPLETED:
      return 'Completed'
    case STATUS_CAMPAIGN_ENUM_DRAFT:
      return 'Draft'
    case STATUS_CAMPAIGN_ENUM_ARCHIVE:
      return 'Archived'

    default:
      break
  }
}

export const prepareCampaignsData = dashboardsData => ({
  ...dashboardsData,
  missionType: getMissionType(dashboardsData.type),
  readableStatus: getReadableStatus(dashboardsData.status),
})

export const filterLocationName = locations =>
  locations.reduce((acc, location) => {
    if (location) {
      if (!location.isSelfServe) {
        acc.push(location.name)
      }
    } else {
      acc.push('-')
    }

    return acc
  }, [])

export const CAMPAIGN_ORDER_BY_ENUM = {
  NAME_ASC: 'NAME_ASC',
  STARTDATE_DESC: 'STARTDATE_DESC',
}
export const CAMPAIGN_SORTING_OPTIONS = [
  {
    label: 'Alphabetically a-z',
    value: CAMPAIGN_ORDER_BY_ENUM.NAME_ASC,
  },
  {
    label: 'Newest first',
    value: CAMPAIGN_ORDER_BY_ENUM.STARTDATE_DESC,
  },
]
